module.exports = __webpack_public_path__ + "img/prediction.01b1be84.svg";